import { render, staticRenderFns } from "./App.vue?vue&type=template&id=50f096a7&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=50f096a7&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=50f096a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f096a7",
  null
  
)

export default component.exports